import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-split-right, rules, direction, split"><path d="M14.75 20.25H20.25V14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 9.25V3.75H14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 12H3.75M12 12L19.5 19.5M12 12L19.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowSplitRight;
